import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AdminPortalAPIHttpClient } from '../../../infrastructure/http/v2/AdminPortalAPIHttpClient';
import { AutoHostReviewReasons } from '../models/AutoHostReviewReasons';
import { ScreeningReportRow } from '../models/ScreeningReportRow';
import { ScreeningReportSearchRequest } from '../models/ScreeningReportSearchRequest';

export interface ScreeningReportSearchResult {
  rows: ScreeningReportRow[];
  totalRecords: number;
}

// Formats in the browser's local time zone so the calendar day the user picked is the day sent to the API.
export const toApiDate = (date: Date): string => formatDate(date, 'yyyy-MM-dd', 'en-US');

@Injectable({
  providedIn: 'root'
})
export class ScreeningReportService {

  constructor(private adminPortalApiHttpClient: AdminPortalAPIHttpClient) { }

  search = async (request: ScreeningReportSearchRequest): Promise<ScreeningReportSearchResult> => {
    const response: any = await firstValueFrom(this.adminPortalApiHttpClient.post('/guests/screening-report', request));
    if (!response) {
      throw new Error('Search screening report response null');
    }

    return {
      rows: response.data ?? [],
      totalRecords: response.metaData?.totalRecords ?? 0
    };
  }

  markReviewed = async (screeningId: string): Promise<void> => {
    await firstValueFrom(this.adminPortalApiHttpClient.post(`/guests/screening-report/${screeningId}/review`, {}));
  }

  markPassed = async (screeningId: string): Promise<void> => {
    await firstValueFrom(this.adminPortalApiHttpClient.post(`/guests/screening-report/${screeningId}/pass`, {}));
  }

  returnToQueue = async (screeningId: string): Promise<void> => {
    await firstValueFrom(this.adminPortalApiHttpClient.delete(`/guests/screening-report/${screeningId}/review`));
  }

  getReviewReasons = async (screeningId: string): Promise<AutoHostReviewReasons> => {
    return await firstValueFrom(this.adminPortalApiHttpClient.get(`/guests/screening-report/${screeningId}/autohost-review-reasons`)) as AutoHostReviewReasons;
  }
}
